import axios from 'axios';

// Determine API base URL with sensible production fallbacks
let API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
  if (typeof window !== 'undefined') {
    // If frontend and backend served from same origin in production, use relative /api
    const { hostname, protocol } = window.location;
    // Heroku & similar provide app on same host: just use relative path
    API_URL = '/api';
    // Local dev fallback
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      API_URL = `${protocol}//${hostname}:5000/api`;
    }
  } else {
    API_URL = 'http://localhost:5000/api';
  }
}

// Create axios instance (do not force JSON header so FormData boundary is set automatically)
const api = axios.create({
  baseURL: API_URL,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;